import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faBehance,
    faLinkedin,
    faDribbble,
    faFacebookF,
    faInstagram,
    faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import "./Footer.css";

function footer() {
    return (
        <footer style={{ backgroundColor: "#151515" }}>
            <div className="container text-light py-3">
                <div className="row">
                    <div className="col-lg-8 col-12">
                        <div className="copyright text-lg-start text-center">
                            <span>© Copyright 2018 </span>
                            <span>
                                Design by{" "}
                                <Link
                                    className="text-light text-decoration-none"
                                    to="/"
                                >
                                    styleshout
                                </Link>
                            </span>
                            <span>
                                Distributed by{" "}
                                <Link
                                    className="text-light text-decoration-none"
                                    to="/"
                                >
                                    themewagon
                                </Link>
                            </span>
                        </div>
                    </div>
                    <div className="col-lg-4 col-12">
                        <ul className="nav justify-content-lg-start justify-content-center">
                        <li className="nav-item">
                                <a
                                    href="https://www.linkedin.com/in/ferdous-hasan-dev/"
                                    target="blank"
                                    className="nav-link"
                                >
                                    <FontAwesomeIcon
                                        className="text-light"
                                        icon={faLinkedin}
                                    />
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href="https://www.facebook.com/ferdous.hasan.62245/"
                                    target="blank"
                                    className="nav-link"
                                >
                                    <FontAwesomeIcon
                                        className="text-light"
                                        icon={faFacebookF}
                                    />
                                </a>
                            </li>
                            <li className="nav-item">
                                <a
                                    href="https://www.instagram.com/_hidden__monster_/"
                                    target="blank"
                                    className="nav-link"
                                >
                                    <FontAwesomeIcon
                                        className="text-light"
                                        icon={faInstagram}
                                    />
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default footer;
